document.addEventListener('DOMContentLoaded', function() {
    const select = document.getElementById('mapSelect');
    const svg = document.getElementById('svg-map');
    if (!svg) return;
    const anchors = svg.querySelectorAll('a');
    const blocks = document.querySelectorAll('.estado-bloco');
    const spanEstado = document.querySelector('[data-estado="mostrarEstado"]');

    function mostrarEstado(estadoId) {
        // mostra/esconde blocos
        blocks.forEach(bloco => {
            bloco.style.display = (bloco.id === estadoId) ? 'block' : 'none';
        });

        // pega o texto da option correspondente
        if (spanEstado) {
            const option = select.querySelector(`option[value="#${estadoId}"]`);
            spanEstado.textContent = option ? option.textContent : '';
        }
    }

    // 1️⃣ clique no mapa
    anchors.forEach(a => {
        const href = a.getAttribute('xlink:href') || a.getAttribute('href');
        const estadoId = href.replace('#', '');

        a.addEventListener('click', e => {
            e.preventDefault();
            select.value = href; // sincroniza com o select
            mostrarEstado(estadoId);
        });
    });

    // 2️⃣ seleção manual no select
    select.addEventListener('change', function() {
        const valor = this.value;
        if (valor && valor !== 'null') {
            const estadoId = valor.replace('#', '');
            mostrarEstado(estadoId);
        } else {
            blocks.forEach(bloco => bloco.style.display = 'none');
            if (spanEstado) spanEstado.textContent = '';
        }
    });

    // 3️⃣ inicializa (tudo escondido)
    blocks.forEach(bloco => bloco.style.display = 'none');
    if (spanEstado) spanEstado.textContent = '';
});
